import { ColonistMembershipProduct } from '../../../../../../../shared/store/ColonistMembershipProduct.ts';
import { createDivIn, createParagraphIn } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UICheckoutAjaxEndPoints } from '../../../../../../shared/scripts/ui_checkout/UICheckoutAjaxEndPoints.ts';
import { UIMMobileWebviewCommunication } from '../../../../ui_mobile_communication/UIMMobileWebviewCommunication.ts';
import { MobileWebviewCommunicationActions } from '@colonist/mobile';
import { ClientUserState } from '../../../../../../shared/scripts/ClientUserState.ts';
import { UIStoreMembershipProductView } from '../../../../../../shared/scripts/store/UIStoreMembershipProductView.ts';
import { localizeAnnualToMonthly, localizeMonthlyToAnnual } from '../../../../../../shared/scripts/store/PriceUtils.ts';
import { UIMDeviceHandler } from '../../../UIMDeviceHandler.ts';
import { PaymentMethod } from '../../../../../../../shared/store/BaseColonistStoreProduct.ts';
import { UIDeviceController } from '../../../../../../shared/scripts/ui_html/UIDeviceController.ts';
import { TimeUtils } from '@colonist/utils';
import { UIMDoubleTapPurchaseController } from '../../../store/UIMDoubleTapPurchaseController.ts';
import { sendDoubleTapPaymentAbandonedAnalytic, sendPurchaseSessionStartedAnalytic } from '../../../../../../shared/scripts/analytics/sendPurchaseFunnelAnalytic.ts';
export class UIMStoreMembershipProductView extends UIStoreMembershipProductView {
    showAndroidAnnualPrice() {
        var _this_localizedPriceData, _this_localizedPriceData1;
        if (!this.membershipProduct.billedAnnually) return;
        this.priceDiv.replaceChildren();
        const annualPrice = this.getMembershipPriceString('annual');
        const baseAnnualPrice = ColonistMembershipProduct.getBaseAnnualPriceOfAnnualMembership(this.membershipProduct.type);
        if (baseAnnualPrice == undefined) return;
        const context = ((_this_localizedPriceData = this.localizedPriceData) === null || _this_localizedPriceData === void 0 ? void 0 : _this_localizedPriceData.price) != undefined ? 'localized' : 'biggerPrice';
        const amount = ((_this_localizedPriceData1 = this.localizedPriceData) === null || _this_localizedPriceData1 === void 0 ? void 0 : _this_localizedPriceData1.price) != undefined ? this.localizedPriceData.displayPrice : annualPrice;
        const localizedMonthlyData = this.localizedMonthlyPriceData;
        const hasLocalizedMonthlyPrice = (localizedMonthlyData === null || localizedMonthlyData === void 0 ? void 0 : localizedMonthlyData.price) != undefined;
        const strikethroughAmount = (localizedMonthlyData === null || localizedMonthlyData === void 0 ? void 0 : localizedMonthlyData.price) != undefined ? localizeMonthlyToAnnual(localizedMonthlyData) : baseAnnualPrice;
        const strikethroughContext = hasLocalizedMonthlyPrice ? 'strikethroughLocalized' : 'strikethrough';
        createParagraphIn(this.priceDiv, {
            key: 'strings:storePage.sections.membership.billing.yearlyPayment',
            options: {
                context: strikethroughContext,
                amount: strikethroughAmount
            }
        }, 'strikethrough-price', '');
        this.membershipPrice = createParagraphIn(this.priceDiv, {
            key: 'strings:storePage.sections.membership.billing.yearlyPayment',
            options: {
                context: context,
                amount: amount
            }
        }, '', '');
    }
    sendToCheckout() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return;
        const doubleTapPurchaseController = UIMDoubleTapPurchaseController.getInstance();
        const isDoubleTapPurchaseInitialized = doubleTapPurchaseController != undefined;
        if (!isDoubleTapPurchaseInitialized) {
            this.executeNonDoubleTabCheckout();
            return;
        }
        this.subscribeButton.classList.add('loading');
        doubleTapPurchaseController.startPurchase({
            productName: this.membershipProduct.getProductName(),
            usdCentsAmount: this.getSubscriptionUsdCentsAmount(),
            storeProductType: this.membershipProduct.storeProductType,
            productType: this.membershipProduct.type,
            itemQuantity: this.membershipProduct.itemQuantity,
            onPaymentSheetShown: ()=>sendPurchaseSessionStartedAnalytic({
                    storeProductType: this.membershipProduct.storeProductType,
                    productType: this.membershipProduct.type,
                    method: 'doubleTap'
                }),
            onPurchaseCancel: ()=>sendDoubleTapPaymentAbandonedAnalytic({
                    storeProductType: this.membershipProduct.storeProductType,
                    productType: this.membershipProduct.type
                }),
            onPurchaseFinished: (purchaseResult)=>this.onDoubleTapPurchaseFinished(purchaseResult)
        });
    }
    onDoubleTapPurchaseFinished(purchaseResult) {
        this.subscribeButton.classList.remove('loading');
        if (purchaseResult.shouldExecuteFallbackPurchase) this.executeNonDoubleTabCheckout();
    }
    executeNonDoubleTabCheckout() {
        if (UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true) {
            this.executeNativePaymentPurchase();
            return;
        }
        this.executeStripePurchaseSession();
    }
    executeNativePaymentPurchase() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return;
        this.subscribeButton.classList.add('loading');
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.membershipProduct.storeProductType,
            productType: this.membershipProduct.type,
            method: 'nativeIap'
        });
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.PurchaseMembership, {
            subscriptionId: this.membershipProduct.mobileIAPSKUId,
            userId: ClientUserState.userState.id,
            offerToken: ''
        });
    }
    getSubscriptionUsdCentsAmount() {
        if (!this.membershipProduct.billedAnnually) {
            const monthlyCentsAmount = this.membershipProduct.price;
            return monthlyCentsAmount;
        }
        const annualCentsAmount = this.membershipProduct.price * TimeUtils.MONTHS_IN_YEAR;
        return annualCentsAmount;
    }
    executeStripePurchaseSession() {
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.membershipProduct.storeProductType,
            productType: this.membershipProduct.type,
            method: 'stripeCheckout'
        });
        void UICheckoutAjaxEndPoints.executeStripeColonistProductPurchaseSession(this.membershipProduct.storeProductType, this.membershipProduct.type, this.membershipProduct.itemQuantity);
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true);
    }
    manageSubscription() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        const isStripePaymentMethod = ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.membershipPaymentMethod) == PaymentMethod.Stripe;
        if (UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true && !isStripePaymentMethod && ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.id)) {
            this.subscribeButton.classList.add('loading');
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowManageSubscriptions, {
                subscriptionId: this.membershipProduct.mobileIAPSKUId,
                userId: ClientUserState.userState.id
            });
            return;
        }
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true);
        super.manageSubscription();
    }
    addBestValueHint() {
        if (!this.membershipProduct.bestValue) return;
        this.productDiv.classList.add('store_page_membership_best_value_border');
        const badge = createDivIn(this.headerDiv, 'badge-white badge-lg');
        createParagraphIn(badge, {
            key: 'strings:storePage.bestValue'
        }, '');
    }
    getDisclaimerKey() {
        var _this_localizedPriceData, _this_localizedPriceData1;
        if (!UIDeviceController.isUserOnAndroidApp()) {
            return super.getDisclaimerKey();
        }
        const monthlyPrice = this.getMembershipPriceString('monthly');
        const context = ((_this_localizedPriceData = this.localizedPriceData) === null || _this_localizedPriceData === void 0 ? void 0 : _this_localizedPriceData.price) != undefined ? 'localized' : '';
        const amount = ((_this_localizedPriceData1 = this.localizedPriceData) === null || _this_localizedPriceData1 === void 0 ? void 0 : _this_localizedPriceData1.price) != undefined ? localizeAnnualToMonthly(this.localizedPriceData) : monthlyPrice;
        if (this.membershipProduct.billedAnnually) return {
            key: 'strings:storePage.sections.membership.billing.monthlyEqual',
            options: {
                context: context,
                amount: amount
            }
        };
        return {
            key: 'strings:storePage.sections.membership.billing.monthly'
        };
    }
    constructor(container, storeState, membershipProduct, giftOverlay, localizedSubscription, localizedMonthlySubscription){
        super(container, storeState, membershipProduct, giftOverlay, localizedSubscription, localizedMonthlySubscription);
        if (UIDeviceController.isUserOnAndroidApp()) {
            this.showAndroidAnnualPrice();
        }
        createDivIn(this.subscribeButton, 'loading-spinner');
    }
}
